import { useState, useRef, useEffect } from "react";
import { EventDataContext } from "../EventDataContext";
import { useContext } from "react";
import axios from "axios";
import {
  MdCheckBox,
  MdTextFields,
  MdEdit,
  MdDelete,
} from "react-icons/md";
import { RiArrowUpSLine, RiArrowDownSLine } from "react-icons/ri";
import FileUploadComponent from "../fileUpload/FileUploadComponent";
import { FaRegCheckCircle } from "react-icons/fa";
import { BsSend } from "react-icons/bs";
import {
  IoIosAddCircleOutline,
} from "react-icons/io";
import "../../styling/QuestionnaireTabBusinessCss.css";
import DeleteQuestionModal from "../modals/DeleteQuestionModal";
import businessPhoto from "../../images/BoothBloom_Banner_Business.jpg"
import weddingPhoto from "../../images/BoothBloom_Banner_Wedding.jpg"
import birthdayPhoto from "../../images/BoothBloom_Banner_Birthday.jpg"
import otherPhoto from "../../images/BoothBloom_Banner_Other.jpg"

const QuestionnaireTabBusiness = ({ brandingColours }) => {
  const { EventData, setEventData } = useContext(EventDataContext);
  const [questions, setQuestions] = useState([]);
  
  // --- 1. NEW STATE: To track which question is being hovered over ---
  const [hoveredQuestionIndex, setHoveredQuestionIndex] = useState(null);

  // --- FIX: useEffect dependency corrected to prevent infinite loop ---
  useEffect(() => {
    const initialQuestions = EventData.questionnaire || [];
    const sortedQuestions = [...initialQuestions].sort((a, b) => (a.position || 0) - (b.position || 0));
    setQuestions(sortedQuestions);
  }, [EventData._id]); // Only re-initialize when the Event ID changes

  let coverPic=otherPhoto;
  if(EventData.eventType==="corporate"){
    coverPic=businessPhoto
  } else if(EventData.eventType==="birthday"){
    coverPic=birthdayPhoto
  } else if(EventData.eventType==="wedding"){
    coverPic=weddingPhoto
  }

  useEffect(() => {
    setEventData((prev) => ({
      ...prev,
      questionnaire: questions,
    }));
  }, [questions]);

  const [showQuestionOptions, setShowQuestionOptions] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const optionsBoxRef = useRef(null);

  const handleSendToClient = async () => {
    if (isEdit) {
      alert("Please save your changes before sending to the client.");
      return;
    }
    const updatedQuestions = questions.map(q => ({
      ...q,
      isSentToClient: true,
    }));

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/business/update-questionnaire`,
        {
          eventId:EventData._id,
          questions:updatedQuestions,
        },
        { withCredentials: true }
      );
      setQuestions(updatedQuestions);
      alert("Questionnaire sent to client!");
    } catch (error) {
      console.error('Error sending questionnaire:', error.response?.data || error.message);
      alert("Failed to send questionnaire.");
    }
  };
  
  const handleAddQuestionClick = () => setShowQuestionOptions(!showQuestionOptions);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsBoxRef.current && !optionsBoxRef.current.contains(event.target)) {
        setShowQuestionOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAddQuestion = (type) => {
    const newQuestion = { type, text: "", options: [], extraField: false, isSentToClient:false };
    setQuestions([...questions, newQuestion]);
    setShowQuestionOptions(false);
  };

  const openModal = (index) => {
    setQuestionToDelete(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setQuestionToDelete(null);
  };

  const handleDeleteQuestion = () => {
    if (isEdit && questionToDelete !== null) {
      const updatedQuestions = questions.filter((_, i) => i !== questionToDelete);
      setQuestions(updatedQuestions);
    }
    closeModal();
  };

  const handleInputChange = (index, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index].text = value;
    setQuestions(updatedQuestions);
  };

  const handleAddOption = (index) => {
    if (isEdit) {
      const updatedQuestions = [...questions];
      updatedQuestions[index].options.push("");
      setQuestions(updatedQuestions);
    }
  };

  const moveQuestion = (index, direction) => {
    if ((direction === "up" && index === 0) || (direction === "down" && index === questions.length - 1)) {
      return;
    }
    const updatedQuestions = [...questions];
    const newIndex = direction === "up" ? index - 1 : index + 1;
    [updatedQuestions[index], updatedQuestions[newIndex]] = [updatedQuestions[newIndex], updatedQuestions[index]];
    setQuestions(updatedQuestions);
  };

  const handleEditSave = async () => {
    if (isEdit) {
      setIsSaving(true);
      try {
        const questionsWithPosition = questions.map((q, index) => ({...q, position: index}));
        await axios.put(
          `${process.env.REACT_APP_API_URL}/business/update-questionnaire`,
          { eventId: EventData._id, questions: questionsWithPosition },
          { withCredentials: true }
        );
        setQuestions(questionsWithPosition);
        alert("Questionnaire saved!");
        setIsEdit(false);
      } catch (error) {
        console.error('Error updating questionnaire:', error.response?.data || error.message);
        alert("Failed to save the questionnaire. Please try again.");
      } finally {
        setIsSaving(false);
      }
    } else {
      setIsEdit(true);
    }
  };

  const handleOptionChange = (questionIndex, optionIndex, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[questionIndex].options[optionIndex] = value;
    setQuestions(updatedQuestions);
  };

  return (
    // ADDED: position: "relative" here to anchor the absolute buttons
    <div style={{ width: "100%", position: "relative" }}> 
      <DeleteQuestionModal isModalOpen={isModalOpen} closeModal={closeModal} deleteQuestion={handleDeleteQuestion} />
      <div style={{ position: 'relative', width: '100%', height: '224px', overflow: 'hidden', backgroundColor: '#000' }}>
  {/* 1. The Base Image */}
  <img
    src={coverPic}
    alt="cover"
    style={{ 
      width: "100%", 
      height: "100%", 
      objectFit: "cover",
      objectPosition: "top" 
    }}
  />

  {/* 2. The Blur Overlay */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backdropFilter: 'blur(8px)', // Adjust the blur strength here
    WebkitBackdropFilter: 'blur(8px)',
    // This mask makes the center transparent (clear) and the sides opaque (blurred)
    maskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
    WebkitMaskImage: 'radial-gradient(circle, transparent 30%, black 80%)',
  }} />
  
  {/* 3. The Bottom Gradient & Text Overlay */}
  <div style={{
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '100%',
    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
    color: 'white',
    padding: '20px',
    boxSizing: 'border-box'
  }}>
    <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>
      Your Questionnaire
    </h1>
    <p style={{ margin: '5px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
      Date Booked: {new Date(EventData.eventDate).toLocaleDateString()}
    </p>
  </div>
</div>
      
      <div className="event-overview-content-container">
        <h2 style={{ marginTop: "30px", color: "#000000", marginBottom: "30px", padding: '20px' }}>Event Info</h2>

        {questions.map((question, index) => (
          <div
            key={index}
            onMouseEnter={() => isEdit && setHoveredQuestionIndex(index)}
            onMouseLeave={() => isEdit && setHoveredQuestionIndex(null)}
            style={{
              cursor: "pointer",
              color: "#625C73",
              display: "flex",
              flexDirection: "column",
              marginBottom: "20px",
              padding: "20px",
              position: "relative",
              borderBottom: "1px solid #D9D9D9",
              backgroundColor: isEdit && hoveredQuestionIndex === index ? '#f9f9f9' : 'transparent',
              borderRadius: '5px',
              transition: 'background-color 0.2s ease-in-out',
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="text"
                className="custom-input"
                style={{ flex: 1, border: "none", color: "#080700", fontSize: "16px", padding: "5px", background: 'transparent' }}
                placeholder={question.type === "text" ? "Enter text question here..." : "Enter checkbox question here..."}
                value={question.text}
                onChange={(e) => handleInputChange(index, e.target.value)}
                readOnly={!isEdit}
              />
              {isEdit && hoveredQuestionIndex === index && (
                <div style={{ display: "flex", alignItems: "center", gap: '8px', fontSize: '24px', position: "absolute", right: 5, top: 5 }}>
                  <RiArrowUpSLine
                    onClick={() => moveQuestion(index, 'up')}
                    style={{ cursor: index === 0 ? 'not-allowed' : 'pointer', color: index === 0 ? '#cccccc' : '#4D4D4D' }}
                  />
                  <RiArrowDownSLine
                    onClick={() => moveQuestion(index, 'down')}
                    style={{ cursor: index === questions.length - 1 ? 'not-allowed' : 'pointer', color: index === questions.length - 1 ? '#cccccc' : '#4D4D4D' }}
                  />
                  <span onClick={() => openModal(index)} style={{ cursor: "pointer", color: "#4D4D4D", display: 'flex', alignItems: 'center' }}>
                    <MdDelete size={20} />
                  </span>
                </div>
              )}
            </div>
            {question.type === "checkbox" && (
              <div style={{ marginTop: "15px" }}>
                {question.options.map((option, optionIndex) => (
                  <div key={optionIndex} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                    <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "10px" }} checked={question.isSentToBusiness && question.answer?.includes(option)} readOnly />
                    <input
                      type="text"
                      style={{ border: "none", width: "100%", color: "#4D4D4D", background: 'transparent' }}
                      placeholder="Write option here..."
                      value={option}
                      onChange={(e) => handleOptionChange(index, optionIndex, e.target.value)}
                      readOnly={!isEdit}
                    />
                  </div>
                ))}
                {isEdit && (
                  <h4 style={{ color: "#080700", cursor: "pointer", display: "flex", alignItems: "center", marginTop: "10px" }} onClick={() => handleAddOption(index)}>
                    <IoIosAddCircleOutline size={20} style={{ marginRight: "5px", color: "#2A1980" }} /> Add New Option
                  </h4>
                )}
              </div>
            )}
            {question.type === "text" && question.isSentToBusiness && question.answer && (
              <div style={{ marginTop: "8px", marginLeft:"5px", fontSize: "14px", color: "#7A7A7A" }}>
                Answer: {question.answer}
              </div>
            )}
          </div>
        ))}
        
        <div style={{ padding: '20px' }}>
          <FileUploadComponent brandingColours={brandingColours} user="business" eventId={EventData._id} />
        </div>
        
        <div style={{ position: "relative", display: "inline-block", marginBottom: "20px", padding: '20px' }}>
          {showQuestionOptions && ( <div ref={optionsBoxRef} style={{ width: "260px", padding: "15px", backgroundColor: "#f9f9f9", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 4px 8px rgba(0,0,0,0.1)", marginBottom: "10px" }}> <h4 style={{ color: "#080700", marginBottom: "10px", marginTop: "0px" }}>Add an Element</h4> <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}> <div style={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer" }} onClick={() => handleAddQuestion("checkbox")}> <MdCheckBox size={40} color="#D9D9D9" /> <span style={{ color: "#595959" }}>Checkboxes</span> </div> <div style={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer" }} onClick={() => handleAddQuestion("text")}> <MdTextFields size={40} color="#D9D9D9" /> <span style={{ color: "#595959" }}>Question</span> </div> </div> </div> )}
          {isEdit && ( <h4 style={{ color: "#080700", cursor: "pointer", display: "flex", alignItems: "center", marginTop: "0px", marginLeft: "10px" }} onClick={handleAddQuestionClick}> <IoIosAddCircleOutline size={20} style={{ marginRight: "5px", color: "#2A1980" }} /> Add New Item </h4> )}
        </div>

        {/* BUTTON CONTAINER: Fixed to top-right of this component */}
        <div div className="questionnaire-actions-container" >
          <button 
            style={{ 
              height: "35px", 
              fontSize: "14px", 
              background: "#FFFFFF", 
              color: "#2A1980", 
              border: "1px solid #D9D9D9", 
              cursor: isSaving ? "not-allowed" : "pointer", 
              opacity: isSaving ? 0.6 : 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '5px',
              borderRadius:'5px'
            }} 
            onClick={handleEditSave} 
            disabled={isSaving}
          > 
            {isSaving ? "Saving..." : (<> {!isEdit ? <MdEdit /> : <FaRegCheckCircle />} {isEdit ? "Save" : "Edit"} </>)} 
          </button>
          <button 
            style={{ 
              height: "35px", 
              fontSize: "14px", 
              background: "#2A1980", 
              color: "#FFFFFF", 
              width: "100%", 
              cursor: "pointer",
              border: "none",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '5px',
              borderRadius:'5px'
            }} 
            onClick={handleSendToClient}
          > 
            <BsSend /> Send to Client 
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireTabBusiness;